module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "href": "https://the-line-up.com/newsletters/?utm_source=TLUGOAAAAJ&utm_campaign=9781504067799",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "svg_cover",
    attrs: {
      "alt": "Image",
      "src": "images/tlu-backad.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52a7c022","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/TLU.vue
// module id = 60
// module chunks = 0